var map = {
	"./01-_DSC8507.jpg": 98,
	"./02-_DSC9682.jpg": 99,
	"./03-_DSC9739.jpg": 100,
	"./04-_DSC0329.jpg": 101,
	"./05-_DSC0327.jpg": 102,
	"./06-_DSC1155.jpg": 103,
	"./07-_DSC8452.jpg": 104,
	"./08-_DSC7984.jpg": 105,
	"./09-_DSC0173.jpg": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;